import { SidebarProvider } from "@/components/ui/sidebar";
import { SuperAdminSidebar } from "./SuperAdminSidebar";
import { SuperAdminMobileHeader } from "./SuperAdminMobileHeader";
import { SuperAdminDesktopHeader } from "./SuperAdminDesktopHeader";
import { useIsMobile } from "@/hooks/use-mobile";

interface SuperAdminLayoutProps {
  children: React.ReactNode;
}

export function SuperAdminLayout({ children }: SuperAdminLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="min-h-screen flex w-full bg-gradient-to-br from-super-admin-bg-from via-super-admin-bg-via to-super-admin-bg-to">
        <SuperAdminSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <SuperAdminMobileHeader />
          <SuperAdminDesktopHeader />
          <main className="flex-1 p-3 md:p-6 overflow-x-hidden overflow-y-auto pt-[calc(env(safe-area-inset-top)+4rem)] lg:pt-0 pb-[calc(env(safe-area-inset-bottom)+1rem)]">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
